import { getAgentById, getAgentPage, addAgent, upadteAgent, delAgentById } from '@/api/common/agent'
import { message } from 'ant-design-vue'

export class AgentController {
  static type = [
    { title: '总公司', value: 'headquarters' },
    { title: '按摩', value: 'massage' },
    { title: '家政', value: 'household' }
  ]

  static async page (params: COMMON.API.QueryParams) {
    const { data, code } = await getAgentPage(params)
    return {
      code,
      data: data.records,
      total: data.total
    }
  }

  static async byId (id: string) {
    return getAgentById(id)
  }

  static async del (id: string) {
    const { code, msg } = await delAgentById(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }

  static async add (data: COMMON.AGENT) {
    const { code, msg } = await addAgent(data)
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async update (data: COMMON.AGENT) {
    const { code, msg } = await upadteAgent(data)
    code === 0 ? message.success('编辑成功') : message.error(msg)
    return code
  }
}
